//import { enableBodyScroll, preventBodyScroll } from "Packages/Sites/Muensmedia.AlphaPet/NodeTypes/helper";

window.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector("#main-header");
  if (!header) return;
  const backendMode = document.body.classList.contains("neos-backend");
  const mainNavigation = header.querySelector("#main-navigation");
  const mainNavigationItems = mainNavigation?.querySelectorAll(".menu-item");
  const navigationFlyout = header.querySelector("#navigation-flyout");
  const flyoutItems = navigationFlyout?.querySelectorAll(".flyout-item");
  const flyoutBackdrop = header.querySelector("#flyout-backdrop");
  const language = header.querySelector("#navigation-actions .language");
  const languageFlyout = header.querySelector("#language-flyout");
  if (mainNavigation && mainNavigationItems.length > 0 && navigationFlyout && flyoutItems.length > 0 && flyoutBackdrop && language && languageFlyout) {
    initMainNavigation();
  }
  const mobileNavigationToggle = header.querySelector("#mobile-navigation-toggle");
  const mobileNavigation = header.querySelector("#mobile-navigation");
  const mobileItems = mobileNavigation?.querySelectorAll(".mobile-item");
  let showNavigation = false;
  let languageFlyoutOpen = false;
  if (mobileNavigationToggle && mobileNavigation && mobileItems.length > 0) {
    initMobileNavigation();
  }
  requestAnimationFrame(() => header.classList.add("animated"));
  function initMainNavigation() {
    window.addEventListener("keydown", e => {
      if (e.key === "Escape" && (showNavigation || languageFlyout)) {
        closeFlyout(true);
        toggleLanguageFlyout(false);
      }
    }, {
      passive: true
    });
    flyoutBackdrop.addEventListener("mouseover", () => {
      closeFlyout(true);
      toggleLanguageFlyout(false);
    }, {
      passive: true
    });
    language.addEventListener("click", toggleLanguageFlyout, {
      passive: true
    });
    language.addEventListener("keydown", e => {
      if (e.key === "Enter" && !languageFlyout) toggleLanguageFlyout();
    }, {
      passive: true
    });
    if (backendMode) return;
    mainNavigationItems.forEach(menuItem => {
      menuItem.addEventListener("mouseover", mainNavigationItemHover, {
        passive: true
      });
      menuItem.addEventListener("keydown", e => {
        if (e.key === "Enter") mainNavigationItemHover();
      }, {
        passive: true
      });
      function mainNavigationItemHover() {
        menuItem.dataset.identifier ? openFlyout(menuItem.dataset.identifier) : closeFlyout();
        toggleLanguageFlyout(false);
      }
    });
    function openFlyout(identifier) {
      showNavigation = true;
      for (const menuItem of mainNavigationItems) {
        menuItem.classList.toggle("open", menuItem.dataset.identifier === identifier);
      }
      toggleFlyoutItem(identifier);
      toggleFlyoutBackdrop();
    }
    function closeFlyout() {
      let soft = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      showNavigation = false;
      for (const menuItem of mainNavigationItems) {
        menuItem.classList.remove("open");
      }
      if (!soft) toggleFlyoutItem();
      toggleFlyoutBackdrop();
    }
    function toggleFlyoutItem() {
      let identifier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      for (const flyoutItem of flyoutItems) {
        flyoutItem.classList.toggle("open", flyoutItem.dataset.identifier === identifier);
      }
    }
    function toggleLanguageFlyout(state) {
      languageFlyoutOpen = state ?? !languageFlyoutOpen;
      if (languageFlyoutOpen) closeFlyout();
      languageFlyout.classList.toggle("open", languageFlyoutOpen);
      toggleFlyoutBackdrop();
    }
  }
  function initMobileNavigation() {
    if (backendMode) return;
    mobileNavigationToggle.addEventListener("click", toggleMobileMenu, {
      passive: true
    });
    for (const item of mobileItems) {
      item.addEventListener("click", () => showItemSubmenu(item), {
        passive: true
      });
    }
    function showItemSubmenu(item) {
      item.querySelector(".item-submenu")?.classList.add("open");
    }
  }
  function toggleMobileMenu() {
    showNavigation = !showNavigation;
    mobileNavigationToggle.classList.toggle("open", showNavigation);
    mobileNavigation.classList.toggle("open", showNavigation);
    if (showNavigation === false) {
      for (const item of mobileItems) {
        item.querySelector(".item-submenu")?.classList.remove("open");
      }
    }
    toggleFlyoutBackdrop();
    const openLabel = mobileNavigationToggle.dataset.openLabel;
    const closeLabel = mobileNavigationToggle.dataset.closeLabel;
    if (openLabel && closeLabel) {
      const label = showNavigation ? closeLabel : openLabel;
      mobileNavigationToggle.setAttribute("aria-label", label);
    }
  }
  function toggleFlyoutBackdrop() {
    navigationFlyout.classList.toggle("open", showNavigation);
    flyoutBackdrop.classList.toggle("open", languageFlyoutOpen || showNavigation);
    //languageFlyoutOpen || showNavigation ? preventBodyScroll() : enableBodyScroll(); #TODO: keeps scrolling up on esc key click
  }
});